(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ug-product_dragon"] && !Shopify.designMode) return;
  try {
    (() => {
    const DRAGON_COPY_SELECTOR = '[data-ug-copy-dragon]';

    document.addEventListener('click', async (event) => {
      const button = event.target.closest(DRAGON_COPY_SELECTOR);

      if (!(button instanceof HTMLButtonElement)) return;

      event.preventDefault();

      if (button.classList.contains('copied')) return;

      const textToCopy = button.getAttribute('data-ug-copy-data');

      if (!textToCopy) return;

      const originalText = button.getAttribute('data-copy-default') || button.textContent || 'Copy';
      const successText = button.getAttribute('data-copy-success') || 'copié!';

      const updateCopiedState = () => {
        button.textContent = successText;
        button.classList.add('copied');

        window.setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('copied');
        }, 2000);
      };

      const manualCopyFallback = () => {
        try {
          const textArea = document.createElement('textarea');
          textArea.value = textToCopy;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          textArea.style.top = '-999999px';
          document.body.appendChild(textArea);

          textArea.focus();
          textArea.select();

          const copied = document.execCommand('copy');
          document.body.removeChild(textArea);

          return copied;
        } catch (error) {
          console.error('Fallback copy failed:', error);
          return false;
        }
      };

      try {
        let copied = false;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(textToCopy);
          copied = true;
        } else {
          copied = manualCopyFallback();
        }

        if (copied) {
          updateCopiedState();
        } else {
          window.alert('Failed to copy code. Please select and copy manually.');
        }
      } catch (error) {
        console.error('Copy failed:', error);

        if (manualCopyFallback()) {
          updateCopiedState();
        } else {
          window.alert('Failed to copy code. Please select and copy manually.');
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
